import Joi from '@hapi/joi'

export const WorkerCapturedAuditReportSundryObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group is required`,
        "any.required": `Group is required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity is required`,
        "any.required": `Operation Entity is required`
    }),
    divisionID: Joi.number().allow(0).label("Collection Point"),
    fieldID: Joi.number().required().label("Field").messages({
        "any.invalid": `Field is required`,
        "any.required": `Field is required`
    }),
    mode: Joi.number().allow(0).label("Mode"),
    fromDate: Joi.string().invalid("").required().label("From Date").messages({
        "any.required": `From Date is required`
    }),
    toDate: Joi.string().invalid("").required().label("To Date").messages({
        "any.required": `To Date is required`
    })
}